// ==============================|| OVERRIDES - TABLE CELL ||============================== //

export default function TableHead(theme) {
  return {
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& th': {
            color: theme.palette.primary.main,
            textTransform: 'none',
            fontSize: theme.typography.customFontSize[3],
            fontFamily: theme.typography.fontFamily,
          },
          borderTop: 'none',
          borderColor: `1px solid ${theme.palette.primary.greyThread}`,
        }
      }
    }
  };
}